import { Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "./LandingPage";
import CopaLandingPage from "./CopaLandingPage";
import TscLandingPage from "./TscLandingPage";
import KnitwellLandingPage from "./KnitwellLandingPage";
import FintechLandingPage from "./FintechLandingPage";
import FashionLandingPage from "./FashionLandingPage";
import NovaLandingPage from "./NovaLandingPage";
import VictoriasSecretLandingPage from "./VictoriasSecretLandingPage";
import DemoChooserPage from "./DemoChooserPage";
import { StepRouter } from "./StepRouter";
import { SessionProvider } from "./context/SessionContext";
import { AnalyticsProvider } from "./context/AnalyticsContext";
import { ThemeProvider } from "./context/ThemeContext";
import { ThemeToggle } from "./components/ThemeToggle";
import { TSC_DEMOS, isTscSlug } from "./tsc/tscDemos";
import "./design-tokens.css";
import "./styles.css";

function ExperienceShell() {
  return (
    <SessionProvider>
      <AnalyticsProvider>
        <main className="min-h-screen" style={{ background: "var(--nx-bg)" }}>
          <StepRouter />
        </main>
      </AnalyticsProvider>
    </SessionProvider>
  );
}

// Tractor Supply pages keep the brand's own light look, so they get no theme toggle.
function isTscPage(pathname: string, search: string): boolean {
  const home = pathname.replace(/\/$/, "");
  return Object.values(TSC_DEMOS).some((d) => d.home === home) || isTscSlug(new URLSearchParams(search).get("agent"));
}

export default function NuplayExperienceApp() {
  const { pathname, search } = useLocation();
  return (
    <ThemeProvider>
      <div className="nurix-experience-root">
        {!isTscPage(pathname, search) && <ThemeToggle />}
        <Routes>
          {/* The index is the demo chooser; each vertical keeps its own landing:
              NuPlay Electronics at /retail, Fintech at /fintech, NuPlay Fashion at
              /fashion, Nova Money at /nova, Copa Airlines at /copa, Tractor Supply
              at /tsc, Ann Taylor at /knitwell. */}
          <Route index element={<DemoChooserPage />} />
          <Route path="retail" element={<LandingPage />} />
          <Route path="fintech" element={<FintechLandingPage />} />
          <Route path="fashion" element={<FashionLandingPage />} />
          <Route path="nova" element={<NovaLandingPage />} />
          <Route path="victorias-secret" element={<VictoriasSecretLandingPage />} />
          <Route path="copa" element={<CopaLandingPage />} />
          <Route path="tsc" element={<TscLandingPage />} />
          {/* Multilingual (en / es / hi) clone of the TSC crew: a separate demo with the same pages. */}
          <Route path="multilingual-support-tsc" element={<TscLandingPage demo={TSC_DEMOS["multilingual-support-agent"]} />} />
          <Route path="knitwell" element={<KnitwellLandingPage />} />
          <Route path="experience" element={<ExperienceShell />} />
        </Routes>
      </div>
    </ThemeProvider>
  );
}
